import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Proposals from './components/Proposals';
import Team from './components/Team';
import Associations from './components/Associations';
import Events from './components/Events';
import News from './components/News';
import Contact from './components/Contact';
import MapInteractive from './components/MapInteractive';
import Suggestions from './components/Suggestions';
// import Voting from './components/Voting';
import Dashboard from './components/Dashboard';
import Gamification from './components/Gamification';
import Login from './components/Login';
import { authService } from './services/api';
import Register from './components/Register';
import PhotoCarousel from './components/PhotoCarousel';
import { useState, useEffect } from 'react';
import { siteService } from './services/api';
import SaludCiudadano from './components/salud/SaludCiudadano';
import AdminPanel from './components/salud/AdminSalud';
import Salud from './components/Salud';
import DespachoMunicipalBanner from "./components/despacho/components/DespachoMunicipalBanner";

import BannerWithName from './components/BannerWithName';
import Despacho from './components/DespachoMunicipal';
import PageTitle from './components/PageTitle';

// Componente para proteger rutas que requieren autenticación
const ProtectedRoute = ({ children }) => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Componente para la página principal
const Home = () => {
  const isAdmin = authService.isAuthenticated() && authService.getCurrentUser().role === 'admin';

  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    siteService.getSite()
      .then((res) => {
        setSite(res.data.site);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Cargando...</div>;

  return (
    <>
      <Hero />
      {/* <Salud /> */}
      {/* <DespachoMunicipalBanner /> */}
      <Proposals />
      <PhotoCarousel images={site?.carouselImages} />
      <Team />
      <MapInteractive isAdmin={isAdmin}/>
      <Events />
      <News />
      {/* <Contact /> */}
    </>
  );
};

export default function App() {
  const isAdmin = true || authService.isAuthenticated() && authService.getCurrentUser().role === 'admin';
  return (
    <Router>
      <PageTitle />
      <div className="min-h-screen bg-gray-50">
        <style>{`:root { --primary: #69c24d; --dark: #69c24d; }`}</style>
        <Navbar />
        <main>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/familia" element={<BannerWithName />} />
            <Route path="/despacho" element={<Despacho />} />

            <Route path="/" element={<Home />} />
            <Route path="/proposals" element={<Proposals />} />
            <Route path="/salud" element={<SaludCiudadano />} />
            <Route 
              path="/admin-salud" 
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/suggestions" 
              element={
                <ProtectedRoute>
                  <Suggestions />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/gamification" 
              element={
                <ProtectedRoute>
                  <Gamification />
                </ProtectedRoute>
              } 
            />
            <Route path="/team" element={<Team />} />
            <Route path="/associations" element={<Associations />} />
            <Route path="/events" element={<Events />} />
            <Route path="/news" element={<News />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard isAdmin={isAdmin}/>
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<h1>404 - Página no encontrada</h1>} />
          </Routes>
        </main>
        <footer className="bg-black text-white mt-8">
          <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <div>
              <div className="font-bold">SPT - La Guardia</div>
              <div className="text-sm text-gray-300">© {new Date().getFullYear()} SPT - La Guardia</div>
            </div>
            <div className="flex items-center gap-3">
              <a className="text-sm" href="/proposals">Propuestas</a>
              <a className="text-sm" href="/team">Personas</a>
              <a className="text-sm" href="/contact">Contacto</a>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}
